/**
 * 필모그래피 중복 판정
 *
 * 규칙: 비교 대상 필드가 "전부" 같아야 중복이다.
 * 하나라도 다르면 별개 작품으로 본다 — 같은 작품에 다른 배역으로 참여하거나,
 * 같은 제목이 다른 연도에 리메이크되는 경우가 실제로 있기 때문.
 */

// 공백·대소문자 차이는 오탈자 수준이라 같은 값으로 취급한다
const norm = (v) => String(v ?? '').trim().replace(/\s+/g, ' ').toLowerCase();

const FIELDS = ['title', 'year', 'company', 'mediaType', 'role', 'videoUrl'];

/** 비교용 키 — 모든 필드를 구분자와 함께 이어 붙인다 */
export const workSignature = (w) => FIELDS.map((f) => norm(w?.[f])).join('');

export const isSameWork = (a, b) => workSignature(a) === workSignature(b);

/**
 * 기존 목록에 없는 작품만 추려낸다. 들어온 목록 안의 중복도 함께 제거.
 * @returns {{ added: Array, skipped: number }}
 */
export function dedupeAgainst(existing, incoming) {
  const seen = new Set((existing ?? []).map(workSignature));
  const added = [];
  let skipped = 0;
  for (const w of incoming ?? []) {
    const sig = workSignature(w);
    if (seen.has(sig)) {
      skipped += 1;
      continue;
    }
    seen.add(sig);
    added.push(w);
  }
  return { added, skipped };
}

/**
 * 화면에서만 쓰는 임시 행 ID.
 * 서버 ID(양수)와 절대 겹치지 않도록 음수를 쓴다 —
 * 예전에는 Date.now()나 max+1을 써서 서버 ID처럼 보이는 값이 만들어졌다.
 */
export const nextLocalWorkId = (works) =>
  Math.min(0, ...(works ?? []).map((w) => Number(w.id) || 0)) - 1;
